<!-- <ng-progress color="red" [thick]="true" [showSpinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'"></ng-progress> -->

<div class="subBlockContainer">
  <!-- <div class="pageTitle" id="subBlock">
        <app-breadcrumb lastRoute='Result' (notify)='onClicked($event)'></app-breadcrumb>
        <i class="material-icons pullfloat-right" (click)='close()'>close</i>
    </div> -->
  <div class="subBlockContent">
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="title blade-title-font">
          Results
          <ng-container *ngIf="searchedKeyword">
            for {{searchedKeyword}}
          </ng-container>
          <!-- <span *ngIf="brandsParams != ''">
             brands: {{ brandsParams }}
          </span>
          <span *ngIf="typesParams != ''">
              types: {{ typesParams }}
           </span>
           <span *ngIf="catsParams != ''">
              categories: {{ catsParams }}
           </span>
           <span *ngIf="seriesParams != ''">
              series: {{ seriesParams }}
           </span> -->
        </div>
      </div>
      <i class="material-icons closebutton-pullfloat-right" (click)='close()'>close</i>

      <div class="filter-wrapper">
        <ng-container *ngIf="!hasEmptyResult">
          <div class="col-md-3">
            <div class="searchInputGroup margin-l-x0">
              <div class="searchIcon">
                <img src="../images/new_ui/filter.png">
              </div>
              <!-- <input class="searchInput" type="text" #searchValue [value]="[searchedKeyword]" placeholder="Filter" (keyup.enter)="searchProducts(searchValue.value)"> -->
              <input class="searchInput" type="text" #searchValue placeholder="Filter" onfocus="this.placeholder=''"
                onblur="this.placeholder='Filter'" [(ngModel)]="filterInput" (ngModelChange)="onChange()">
            </div>
          </div>

        </ng-container>
      </div>

      <ng-container *ngIf="(hasEmptyResult && globallySearch) || hasEmptyFilterResult">
        <div class="noResult-wrapper">
          <div class="top-divider"></div>
          <div><img src="../images/new_ui/no-found.png"></div>
          <div>No results found</div>
          <div>Sorry, that search or filter combination has no results.<br>Please try different criteria.</div>
          <button *ngIf="hasEmptyFilterResult" (click)="close()" class="button button-red button-large">Try
            again</button>
          <button *ngIf="hasEmptyResult && globallySearch" (click)="close()" class="button button-red button-large">Try
            again</button>
          <div class="noResult-feedback" style="display: none;" (click)="sendFeedback($event);">Send feedback</div>
        </div>
        <div class="top-divider"></div>
      </ng-container>

      <ng-container *ngIf="!hasEmptyResult && !hasEmptyFilterResult">
        <div class="top-divider"></div>
        <!-- Show when have 1000 items-->
        <ng-container *ngIf="searchResult?.length >= 1000">
          <div class="moreinfo">
            <div class="row">
              <div class="col-4 align-right"><img src="../images/new_ui/view-more-results.png"></div>
              <div class="col-6 margin-auto">Your search has returned more than 1000 results please update you
                search criteria to
                narrow the result set</div>
              <div class="col-2"></div>
            </div>
          </div>
        </ng-container>
        <!-- End Show when have 1000 items-->
        <div class="shared-outer-wrapper">
          <table matSort (matSortChange)="sortData($event)" class="white width-x100">
            <thead>
              <tr class="row">
                <th mat-sort-header="des" class="col-7">DESCRIPTION</th>
                <th mat-sort-header="soh" class="col-1">SOH</th>
                <th mat-sort-header="price" class="col-2">PRICE EX GST</th>
                <th mat-sort-header="qty" class="col-1">QTY</th>
                <th class="col-1"></th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngFor="let i = index; let item of sortedData | searchResultFilter: selectedBrands : selectedTypes : selectedCategories : selectedSeriese : filterInput : sortingInfoObj : testingString">
                <tr class="row product-wrapper">
                  <td class="col-7">
                    <a class="result_desc" routerLink='/product/{{item?.lr_stock_code}}'
                      (click)="checkProductDetail(item?.lr_stock_code)">
                      {{item?.lr_stk_description}}
                    </a>
                  </td>
                  <td class="col-1 align-right soh-padding-right">
                    {{sohLoad(item?.lr_avail_qty, item?.lr_max_avail_qty)}}
                  </td>
                  <td class="col-2 align-right price-padding-right">
                    {{item?.lr_stk_price | currency:'AUD':'symbol-narrow':'.2-2'}}
                  </td>
                  <td class="col-1">
                    <input integerOnly class="input-wrapper input-wrapper-small align-center" type="text"
                      [value]="inputQtyArr[item.lr_stock_code]" [(ngModel)]="inputQtyArr[item.lr_stock_code]">
                  </td>
                  <td class="col-1 button-margin-top">
                    <button class="button button-red button-small" id="addcartbtn{{item.lr_stock_code}}"
                      (click)="addToCart($event, item)">Add</button>
                  </td>
                  <div class="row product-secondary-wrapper">
                    <div>
                      <span class="light-text">BRAND:&nbsp;</span>
                      <span>{{item?.lr_stk_brand}}</span>
                      <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                      <span class="light-text">STATUS:&nbsp;</span>
                      <span *ngIf="item.lr_stock_status == 'A' || !item.lr_stock_status">ACTIVE</span>
                      <span *ngIf="item.lr_stock_status == 'C'">CLEARANCE</span>
                      <span *ngIf="item.lr_stock_status == 'P'">PROMOTION</span>
                      <span
                        *ngIf="item.lr_stock_status != 'A' && item.lr_stock_status != 'C' && item.lr_stock_status != 'P' && item.lr_stock_status">OBSOLETE</span>
                      <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                      <span class="light-text">SKU:&nbsp;</span>
                      <span>{{item?.lr_stock_code}}</span>
                      <span class="divider-wrapper"
                        *ngIf="!item?.lr_eta.includes('1900')">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                      <span class="light-text" *ngIf="!item?.lr_eta.includes('1900')">ETA:&nbsp;</span>
                      <span *ngIf="!item?.lr_eta.includes('1900')">{{item?.lr_eta | date:'shortDate'}}</span>
                      <span class="divider-wrapper" *ngIf="item?.lr_lead_time">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                      <span class="light-text" *ngIf="item?.lr_lead_time">STANDARD LEAD TIME:&nbsp;</span>
                      <span *ngIf="item?.lr_lead_time">{{item?.lr_lead_time}} Day(s)</span>
                    </div>
                  </div>
                  <div class="row result-additional-info">
                    <div *ngIf="item.lr_stock_type =='K'" class="bundle-wrapper text-font">
                      <img class="center" src="../images/new_ui/bundle.png">
                      <div class="bold-text center">BUNDLE</div>
                    </div>
                    <div *ngIf="item.showPromo" class="promotion-wrapper text-font">
                      <img class="center" src="../images/new_ui/promotion.png">
                      <div class="bold-text center">PROMOTION:</div>
                      <div class="light-text center">ENDS ON {{item.lr_promo_finish}}</div>
                    </div>
                  </div>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
        <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"></pagination-controls> -->

      </ng-container>
    </div>

    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
  </div>
</div>

<router-outlet></router-outlet>